import { FeeType } from 'types/incentive';
import {
  normalizeNonNegativeValue,
  normalizePercentageValue,
} from './IncentiveSettings.percentages';

export const normalizeAdditionalFeeAmount = (
  value: number,
  feeType: FeeType,
) => {
  return feeType === FeeType.PERCENTAGE
    ? normalizePercentageValue(value)
    : normalizeNonNegativeValue(value);
};
